import React, { useEffect } from 'react';
import { render } from 'react-dom';
import './App.css';
import Login from './components/login/Login.js';
import CheckAuth from './components/login/Checkauth.js';
import Base from './components/base/Base.js';

function App() {

	useEffect(() => {
    	// check previous authentication
    	if (window.sessionStorage.getItem("token")) {
      		if (CheckAuth(window.sessionStorage.getItem("token"))){
        		return render(<Base />, document.getElementById('root'));
      		}
    	}
  	},[]);

	return (<Login />);
}

export default App;
